import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, Directive, ViewChild, ElementRef } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
//models

import { ComboTurmaModel } from '../../../providers/model/combo-turma.model';
import { DisciplinaResultadoTradicionalModel } from '../../../providers/model/disciplina-resultado-tradicional.model';
//services

import { ParciaisModel } from '../../../providers/model/parciais.model';
import { ConsultaTradicionalService } from '../../../providers/service/tradicional/consulta-tradicional.service';
export class ConsultaComponent implements OnInit {

  subscription: Subscription;
public habilitarCarregando: boolean = false;
public codigoEmpresa: number;
public codigoInstituicao: number;
public rgmAluno: number;
public codigoAluno: number;
public listaCombo: ComboTurmaModel[];
public turmaSelecionada: number;
public listaDisciplina: DisciplinaResultadoTradicionalModel[];
/**
 * @param {?} consulta
 * @param {?} rotaAtivada
 */
constructor(private consulta: ConsultaTradicionalService,
private rotaAtivada: ActivatedRoute,
  ) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rotaAtivada.params.subscribe(p => {
      this.codigoEmpresa = p['codigoEmpresa'];
      this.codigoInstituicao = p['codigoInstituicao'];
      this.rgmAluno = p['rgmAluno'];
      this.codigoAluno = p['codigoAluno'];

      this.buscaCombo();
    });
  }
/**
 * @return {?}
 */
public buscaCombo() {
    this.habilitarCarregando = true;
    this.subscription = this.consulta.getCombo(this.codigoEmpresa, this.codigoInstituicao, this.rgmAluno)
      .subscribe(
        (element: ComboTurmaModel[]) => {
          this.subscription.unsubscribe();
          this.habilitarCarregando = false;
          this.listaCombo = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao carregar combo", error)
        }
      );
  }
/**
 * @param {?} item
 * @return {?}
 */
public changeCombo(item: any) {
    this.turmaSelecionada = item;

    this.buscaDisciplina(this.codigoEmpresa, this.codigoInstituicao, this.codigoAluno, this.turmaSelecionada);
  }
/**
 * @param {?} codigoEmpresa
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public buscaDisciplina(codigoEmpresa: number, codigoInstituicao: number, codigoAluno: number, codigoTurma: number) {
    this.habilitarCarregando = true;

    this.subscription = this.consulta.getDisciplinas(codigoEmpresa, codigoInstituicao, codigoAluno, codigoTurma)
      .subscribe(

        (retornoDisciplina: DisciplinaResultadoTradicionalModel[]) => {
          this.subscription.unsubscribe();
          this.habilitarCarregando = false;

          this.habilitarCarregando = false;

          retornoDisciplina.forEach(element => {
            if (!element.mediaFinal) {
              element.mediaFinal = "S/N"
            }

            if (!element.resultado) {
              element.resultado = "Sem Resultado"
            }

            if (!element.notaA1) {
              element.notaA1 = "S/N"
            }

            if (!element.notaA2) {
              element.notaA2 = "S/N"
            }

            if (!element.notaA3) {
              element.notaA3 = "S/N"
            }

            if (!element.notaA4) {
              element.notaA4 = "S/N"
            }
          });

          this.listaDisciplina = retornoDisciplina;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao montar disciplinas", error)
        }
      )
  }
/**
 * @param {?} item
 * @return {?}
 */
public linhaSelecionada(item: DisciplinaResultadoTradicionalModel) {

    let /** @type {?} */ divParcial = document.getElementById("collapse-" + item.codigoDisciplina);

    if (divParcial.className == "collapse") {
      this.buscaParcial(item, this.codigoInstituicao, this.rgmAluno);
    } else {
      item.parcial = [];
    }
  }
/**
 * @param {?} disciplina
 * @param {?} codigoInstituicao
 * @param {?} rgmAluno
 * @return {?}
 */
private buscaParcial(disciplina: DisciplinaResultadoTradicionalModel, codigoInstituicao: number, rgmAluno: number) {
    this.habilitarCarregando = true;

    this.subscription = this.consulta.getParciais(disciplina.codigoOferta, codigoInstituicao, rgmAluno)
      .subscribe(
        (element: ParciaisModel[]) => {
          this.subscription.unsubscribe();
          this.habilitarCarregando = false;

          disciplina.parcial = element;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log(error, " ###Erro ao montar parciais");
        })
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-consulta',
  template: `
    <app-carregando *ngIf="habilitarCarregando"></app-carregando>

    <div style="text-align:center">
      <h1>
        Nota Tradicional
      </h1>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <label for="comboTurma">Turma</label>
          <select class="form-control" id="comboturma" name="ComboTurma" [(ngModel)]="turmaSelecionada" (change)="changeCombo($event.target.value)">
            <option *ngFor="let item of listaCombo" [value]="item.codigoTurma">{{item.descricao}}</option>
          </select>
        </div>
      </div>
      <br>

      <div class="panel panel-default">
        <!-- Default panel contents -->
        <div class="table-responsive"></div>

        <!-- Table -->
        <table id="tableDisciplina" class="table table-bordered">
          <thead>
            <th>Disciplina</th>
            <th>Notas Parciais</th>
            <th>Nota-A1</th>
            <th>Nota-A2</th>
            <th>Nota-AF</th>
            <th>Média Final</th>
            <th>Resultado</th>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaDisciplina">
              <td>{{item.codigoDisciplina}} - {{ item.descricaoDisciplina }}
                <div id="accordion">
                  <div class="card">
                    <div #someInput id="collapse-{{item.codigoDisciplina}}" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                      <div class="card-body">
                        <h4>
                          Avaliações/Atividades
                        </h4>

                        <table class="table table-bordered">
                          <th>
                            Descrição
                          </th>
                          <th>
                            Nota
                          </th>
                          <tr *ngFor="let digitada of item.parcial">
                            <td>
                              {{digitada.descricao}}
                            </td>
                            <td>
                              {{digitada.nota}}
                            </td>
                          </tr>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <button type="button" class="btn btn-link" title="Select Financial Instrument" data-toggle="collapse" [attr.data-target]="'#collapse-' + item.codigoDisciplina"
                  aria-expanded="true" aria-controls="collapseOne" [attr.aria-labelledby]="'#heading-'+ item.codigoDisciplina"
                  (click)="linhaSelecionada(item)">
                  <span class="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
                </button>
                Ver detalhes
              </td>
              <td>{{ item.notaA1 }}</td>
              <td>{{ item.notaA2 }}</td>
              <td>{{ item.notaA3 }}</td>
              <td>{{ item.mediaFinal }}</td>
              <td>{{ item.resultado }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  `,
  styles: [`
    th {
        background-color: #DBEBFF;
        border: 1px solid #A4BED4;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 10px;
        color: #006699;
        font-weight: bold;
        text-align: center;
        cursor: default;
    }

    td{
        border: 1px solid #cccccc;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 9px;
    }

    .tabela_atencao {
        border: 1px solid #FFCC00;
        background-color: #FFF8D9;
        font: 10px Verdana, Arial, Helvetica, sans-serif;
        color: #CC0000;
        text-align: center;
    }
  `],
  providers: [ConsultaTradicionalService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConsultaTradicionalService, },
{type: ActivatedRoute, },
];
}

function ConsultaComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaComponent.ctorParameters;
/** @type {?} */
ConsultaComponent.prototype.subscription;
/** @type {?} */
ConsultaComponent.prototype.habilitarCarregando;
/** @type {?} */
ConsultaComponent.prototype.codigoEmpresa;
/** @type {?} */
ConsultaComponent.prototype.codigoInstituicao;
/** @type {?} */
ConsultaComponent.prototype.rgmAluno;
/** @type {?} */
ConsultaComponent.prototype.codigoAluno;
/** @type {?} */
ConsultaComponent.prototype.listaCombo;
/** @type {?} */
ConsultaComponent.prototype.turmaSelecionada;
/** @type {?} */
ConsultaComponent.prototype.listaDisciplina;
/** @type {?} */
ConsultaComponent.prototype.consulta;
/** @type {?} */
ConsultaComponent.prototype.rotaAtivada;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
